import { useEffect, MutableRefObject } from "react";
interface FlatpickrController {
  clear(): void;
  close(): void;
  input: HTMLInputElement;
  readonly calendarContainer: HTMLDivElement;
}

export function useClearDatePicker(
  date: Date | undefined,
  ref: MutableRefObject<FlatpickrController | null>
) {
  useEffect(() => {
    if (date === undefined && ref?.current) {
      ref?.current.clear();
    }
  }, [date]);
}
